export const DASHBOARDTIMELIST_SEARCH = 'DASHBOARDTIMELIST_SEARCH';
export const DASHBOARDTIMELIST_PAGE = 'DASHBOARDTIMELIST_PAGE';
export const DASHBOARDTIMELIST_STATUS = 'DASHBOARDTIMELIST_STATUS';